// In this file we will have all the animation functions
// So that we will call them from any svelte component easily
// Complex animations will be composed from smaller functions

import { gsap, Back, Power1, Power2, Power3, Power4 } from "gsap"
import { get } from "svelte/store"
import { state, mode, planets, newPlanet, sounds } from "./stores.js"

// import { createEventDispatcher } from "svelte"
// Does not work outside a svelte component
// const dispatch = createEventDispatcher()

// I should probably refactor this to put the animations
// to their respective components

let timelines = { bubbles: [] }
let subtleTimeline = gsap.timeline();
// let gameState = get(state)

/*************  Animating stars *************/

export function speedUpStars() {
  if (timelines.stars2.isActive()) {
    gsap.to(timelines.stars1, {
      timeScale: 30,
      ease: Back.easeIn,
      duration: 1,
    }) // Causes bug with Back.easeIn and more than 10 in timeScale
    gsap.to(timelines.stars2, {
      timeScale: 30,
      ease: Back.easeIn,
      duration: 1,
    }) // Causes bug with Back.easeIn and more than 10 in timeScale
  }

  // If i want to insert this in another timeline we have to return a timeline object
  // But we have multiple timelines going on here so maybe i have to return a generic gsap.timeline object?
  return gsap.timeline();
}

export function slowDownStars() {
  if (timelines.stars2.isActive()) {
    gsap.to(timelines.stars1, {
      timeScale: 1,
      ease: Power1.easeOut,
      duration: 2,
    })
    gsap.to(timelines.stars2, {
      timeScale: 1,
      ease: Power1.easeOut,
      duration: 2,
    })
  }
}

export function animStars() {
  let dur = 40

  timelines.starsFirst = gsap
    .timeline({
      defaults: { ease: "none" },
      onComplete: () => {
        timelines.starsFirst.kill()
        document.getElementById("star-block-first").remove()
        delete timelines.starsFirst
        // console.log(timeLines);
      },
    })
    .fromTo("#star-block-first", { y: 0 }, { y: "100vh", duration: dur / 2 })
    .fromTo(
      "#star-block-first",
      { opacity: 0 },
      { opacity: 1, duration: 1 },
      "<"
    )
  // console.log(timeLines);

  timelines.stars1 = gsap
    .timeline({
      repeat: -1,
      defaults: { ease: "none" },
      // onRepeat: repositionStars,
      // onRepeatParams: ["star-block-1"],
    })
    .fromTo("#star-block-1", { y: "-100vh" }, { y: "100vh", duration: dur })

  timelines.stars2 = gsap
    .timeline({
      repeat: -1,
      defaults: { ease: "none" },
      paused: true,
      // onRepeat: repositionStars,
      // onRepeatParams: ["star-block-2"],
    })
    .fromTo("#star-block-2", { y: "-100vh" }, { y: "100vh", duration: dur })

  // After many tries with onComplete and onRepeat callbacks
  // This is the best way to apply a delay only on first run!
  gsap.delayedCall(dur / 2, function () {
    timelines.stars2.play()
  })
}

export function animBgStars() {
  let dur = 100

  gsap
    .timeline({
      defaults: { ease: "none" },
      onComplete: () => {
        // timelines.starsFirst.kill()
        document.getElementById("bg-star-block-first").remove()
        // delete timelines.starsFirst
        // console.log(timeLines);
      },
    })
    .fromTo("#bg-star-block-first", { y: 0 }, { y: "100vh", duration: dur / 2 })
    .fromTo(
      "#bg-star-block-first",
      { opacity: 0 },
      { opacity: 1, duration: 1 },
      "<"
    )
  // console.log(timeLines);

  gsap
    .timeline({
      repeat: -1,
      defaults: { ease: "none" },
    })
    .fromTo("#bg-star-block-1", { y: "-100vh" }, { y: "100vh", duration: dur })

  let bgStars2 = gsap
    .timeline({
      repeat: -1,
      defaults: { ease: "none" },
      paused: true,
    })
    .fromTo("#bg-star-block-2", { y: "-100vh" }, { y: "100vh", duration: dur })

  // After many tries with onComplete and onRepeat callbacks
  // This is the best way to apply a delay only on first run!
  gsap.delayedCall(dur / 2, function () {
    bgStars2.play()
  })
}

function repositionStars(target) {
  // It creates a small gap between the two moving star-blocks
  // It also makes the animation stuttery
  // Maybe we sould not run this when speedUpStars is active or not at all
  // Maybe it's not nessescary. We will see
    console.log(target);
  // let stars = document.getElementById(target).querySelectorAll(".star");
  // for (const star of stars) {
  //   // console.log(star);
  //   star.style.left = utils.getRandInt(0, 99) + "%";
  //   star.style.top = utils.getRandInt(0, 99) + "%";
  // }
}

// End animating stars

/*************  Rocket animations *************/

function vraxionas(action) {
  let tl = gsap.timeline()
  // console.log('vraxionas start')
  if (action === "close")
  tl.to("#praxi", {
    rotation: -90,
    duration: 1,
    transformOrigin: "right center",
    ease: Power2.EaseOut,
  })
  else
  tl.fromTo(
    "#praxi",
    { rotation: -90, transformOrigin: "right center" },
    { rotation: 0, ease: Power2.EaseIn, duration: 1,
      onComplete: () => {
        newPlanet.set(false)
        if (!get(state).finished) {
          animBubbles("show")
          animNumbers()
          // subtleAnimRocket();
        }
      },
    })

  // console.log('vraxionas end')
  return tl
}

function subtleAnimRocket(){
  subtleTimeline = gsap.timeline({repeat: -1, yoyo: true}).to('#rocket', {y: -20, duration: 5 });
}

function initRocket() {
  // console.log('initRocket start')
  // Κρύψε τον βραχίονα
  gsap
  .timeline()
  .set("#praxi", { rotation: -90, transformOrigin: "right center" })
  .set(".fuel-cell", { clearProps: "all" })

  // console.log('initRocket end')
  // .set("#target_number", { clearProps: "all" })
}

export function animNumbers() {
  let currentMode = get(mode)

  if (currentMode === "easy") {
    return gsap
      .timeline()
      .add(animateFromTo("solution1-anim", "solution1", "solution1-inner"))
      .add(animateFromTo("solution2-anim", "solution2", "solution2-inner"))
  } else {
    return animateFromTo(
      "target_number",
      "target-container",
      "target-inside-rocket"
    )
  }
}

export function rocketEntry() {
  newPlanet.set(true)
  // console.log('new planet anim')
  initRocket()
  gsap
    .timeline({
      onStart: () => {
        // console.log('rockeEntry Anim started')
        planetAnim()
      },
      onComplete: () => {
        // console.log('rockeEntry Anim completed')
        vraxionas("open")
      },
    })
    // .timeScale(1.5)
    // .add()
    // .add("entry")
    .fromTo(
      "#rocket",
      { y: "70vh" },
      { y: 0, ease: Power2.EaseOut, duration: 3 },
      // "entry"
    )
    // .add(planetAnim(), "entry") // We don't want this to block other animations so we don't invoke it as a function
    // .add(vraxionas("open"))
  // .add(animBubbles("show"))
  // .add(animateTargetNumber)
  // Now this requires some explanation:
  // If we want the tweens to chain we should use parantheses around the function calls..
  // If we do, the function will be queued to be played in sequence BUT will be called immediatly!
  // But animateTargetNumber should be called only after the rocket has taken it's final place
  // That's why we need to add a delay to the final animation

  // TweenMax.set("#target_number", { x: 0, y: 0, opacity: 0 });
}

export function rocketLaunch() {
  // subtleTimeline.clear();
  let rocket = gsap.timeline({
    onComplete: function () {
      // dispatch("planetEntry")
      // console.log('rocketLaunch Anim completed')
      rocketEntry();
      slowDownStars();
    },
  })
  rocket
    .add(vraxionas("close"))
    .add(animBubbles("hide"))
    // .add(fadeOutTargets())
    .add("launch")
    .to(
      timelines.planet,
      {
        duration: 1,
        timeScale: 140,
        ease: Power4.easeIn,
      },
      "launch"
    )
    .to("#rocket", { y: "-150vh", ease: Back.easeIn, duration: 1.5 }, "launch")
    .add(speedUpStars, "launch")
    .to("#rocket", {duration: 3}) // Just wait X seconds
    // .add(rocketEntry, "+=3")
    // .add(slowDownStars, '+=3')
}

export function animCell() {
  let gameState = get(state)
  let targetCell = document.getElementById("fuel-cell" + gameState.currentCell)

  let tl = gsap.timeline()
  tl.fromTo(
    targetCell,
    1.5,
    { scale: 0, transformOrigin: "50% 50%" },
    { opacity: 1, scale: 1, ease: Power4.EaseOut }
  )

  return tl
}

// End rocket animations

// export function animateTargetNumber() {
//   let targetNumberForAnimation = document.getElementById("target_number")
//   let numberInsideRocket = document.getElementById("target-container")
//   // console.log(numberInsideRocket)

//   let cords1 = targetNumberForAnimation.getBoundingClientRect()
//   let cords2 = numberInsideRocket.getBoundingClientRect()

//   let offsetX = cords2.left - cords1.left
//   let offsetY = cords2.top - cords1.top

//   // console.log(offsetX, offsetY)

//   let test = gsap.fromTo(
//     targetNumberForAnimation,
//     {
//       scale: 10,
//       width: cords2.width,
//       height: cords2.height,
//       x: offsetX,
//       y: offsetY,
//       opacity: 0,
//     },
//     {
//       duration: 0.6,
//       scale: 1,
//       opacity: 1,
//       // backgroundColor: "#97DD77",
//       transformOrigin: "center center",
//       ease: Power4.easeOut,
//       onComplete: () => {
//         document.getElementById("target-inside-rocket").innerHTML =
//           targetNumberForAnimation.innerHTML
//         targetNumberForAnimation.style.opacity = "0"
//         gsap.set(targetNumberForAnimation, { x: 0, y: 0 })
//       },
//     }
//   )

//   return test
// }

export function animateFromTo(id1, id2, embedId) {
  let targetNumberForAnimation = document.getElementById(id1)
  let numberInsideRocket = document.getElementById(id2)
  // console.log(numberInsideRocket)

  let cords1 = targetNumberForAnimation.getBoundingClientRect()
  let cords2 = numberInsideRocket.getBoundingClientRect()

  let offsetX = cords2.left - cords1.left
  let offsetY = cords2.top - cords1.top

  // console.log(offsetX, offsetY)

  let test = gsap.fromTo(
    targetNumberForAnimation,
    {
      scale: 10,
      width: cords2.width,
      height: cords2.height,
      x: offsetX,
      y: offsetY,
      opacity: 0,
    },
    {
      duration: 0.6,
      scale: 1,
      opacity: 1,
      // backgroundColor: "#97DD77",
      transformOrigin: "center center",
      ease: Power4.easeOut,
      onComplete: () => {
        document.getElementById(embedId).innerHTML =
          targetNumberForAnimation.innerHTML
        targetNumberForAnimation.style.opacity = "0"
        gsap.set(targetNumberForAnimation, { x: 0, y: 0 })
      },
    }
  )

  return test
}

// export function targetNumberFadeOut() {
//   let target = document.getElementById("target-inside-rocket")
//   gsap.to(target, {
//     opacity: 0,
//     duration: 1,
//     onComplete: () => {
//       target.innerHTML = ""
//       target.style.opacity = "1"
//     },
//   })
// }

export function fadeOutTargets() {
  let currentMode = get(mode)

  if (currentMode === "easy") {
    return gsap
      .timeline()
      .add(targetFadeOut("solution1-inner"), "together")
      .add(targetFadeOut("solution2-inner"), "together")
  } else {
    return targetFadeOut("target-inside-rocket")
  }
}

export function targetFadeOut(id) {
  let target = document.getElementById(id)
  return gsap.to(target, {
    opacity: 0,
    duration: 1,
    onComplete: () => {
      target.innerHTML = ""
      target.style.opacity = "1"
    },
  })
}

/*************  Planet animations *************/

function changePlanet() {
  let gameState = get(state)
  // console.log(gameState.planetIndex);

  let planetStore = get(planets)
  const planet = document.getElementById("planet")
  if (gameState.planetIndex >= planetStore.length) gameState.planetIndex = 0
  planet.style.backgroundImage = `url("${planetStore[gameState.planetIndex]}")`
  // gameState.planetIndex++
  state.update((obj) => {
    obj.planetIndex++
    return obj
  })

  // console.log(get(state).planetIndex)
}

export function planetAnim() {
  // console.log("planet anim launched")
  if (!timelines.planet) timelines.planet = gsap.timeline()
  // alert("planet anim!")
  changePlanet()
  timelines.planet.timeScale(1)
  timelines.planet
    .fromTo(
      "#planet",
      { y: "-80vh", x: 0, scale: 0.8, ease: Power2.easeOut },
      { duration: 3, y: "-20vh", x: 0, scale: 1 }
    )
    .to("#planet", { duration: 180, y: "100vh", x: "-10vh", scale: 0.6 })
  // return timelines.planet
}

// export function planetExit() {
//   timelines.planet.timeScale(140)
//   return timelines.planet
// }

// End planet animations

/*************  Bubbles animations *************/

export function animBubbles(action = "show") {
  timelines.bubbles = gsap.timeline()
  if (action === "hide")
    timelines.bubbles.staggerTo(
      ".bubble:not(.selected)",
      0.3,
      { opacity: 0, y: -220 },
      0.2
    )
  else
    timelines.bubbles.staggerFromTo(
      ".bubble",
      0.4,
      { opacity: 0, y: 220 },
      { opacity: 1, y: 0 },
      0.2
    )

  return timelines.bubbles
}

export function moveBubble(event) {
  let gameState = get(state)

  get(sounds).click.play()

  let bubble = event.target

  let id = bubble.id.slice(-1)

  // let selectedNums = document.querySelectorAll(".selected").length
  // console.log(test);

  let currentMode = get(mode)

  let target
  if (currentMode === "easy") {
    target = document.getElementById("target-container")
  } else {
    target =
      document.querySelectorAll(".selected").length === 0
        ? document.getElementById("solution1")
        : document.getElementById("solution2")
  }

  let cords1 = bubble.getBoundingClientRect()
  let cords2 = target.getBoundingClientRect()

  let offsetX = cords2.left - cords1.left
  let offsetY = cords2.top - cords1.top

  let newScale = cords2.width / cords1.width

  if (bubble.classList.contains("selected")) {
    bubbleReverse(bubble)
  } else {
    if (gameState.selectedNums < 2) {
      bubble.classList.toggle("selected")

      timelines.bubbles[id] = gsap.to(bubble, 0.4, {
        left: offsetX,
        top: offsetY,
        scale: newScale,
        // backgroundColor: "#97DD77",
        transformOrigin: "0 0",
        ease: Power3.easeOut,
        onComplete: () => {
          state.update((obj) => {
            obj.selectedNums++
            // console.log(obj.selectedNums)
            return obj
          })
        },
      })
    }
  }

  // console.log(gameState)

  // selectedNums = document.querySelectorAll(".selected").length // We have to check again
  // if (selectedNums > 1) checkSolution()
}

export function bubblesToFuel() {
  let bubbles = document.querySelectorAll(".selected")
  let gameState = get(state)

  let tl = gsap.timeline().add("sync")
  bubbles.forEach((bubble) => {
    let target = document.getElementById("fuel-cell" + gameState.currentCell)

    let cords1 = bubble.getBoundingClientRect()
    let cords2 = target.getBoundingClientRect()

    let targetWidth = cords2.right - cords2.left

    let offsetX = cords2.left - cords1.left + targetWidth / 2 - 8
    let offsetY = cords2.top - cords1.top + 3

    // let newScale = cords2.width / cords1.width

    let id = bubble.id.slice(-1)

    let subTl = gsap.timeline()
    subTl
      .to(bubble, {
        x: offsetX,
        y: offsetY,
        scale: 0.2,
        // backgroundColor: "#97DD77",
        transformOrigin: "0 0",
        opacity: 0.5,
        ease: Power4.easeOut,
        duration: 0.8,
      })
      .to(bubble, {
        opacity: 0,
        ease: Power4.easeOut,
        duration: 0.8,
      })

    tl.add(subTl, "sync")
  })

  return tl
}

function bubbleReverse(bubble) {
  let id = bubble.id.slice(-1)
  if (timelines.bubbles[id]) {
    timelines.bubbles[id].reverse()
    state.update((obj) => {
      if (obj.selectedNums > 0) {
        obj.selectedNums--
      }
      return obj
    })
    bubble.classList.toggle("selected")
  }
}

export function moveSelectedBubblesBack() {
  let bubbles = document.querySelectorAll(".selected")
  bubbles.forEach((bubble) => {
    bubbleReverse(bubble)
  })
}

// End Bubble animations

export function animateBgColor(el, toColor = "#ff7941", repeat = 1, duration = 0.5) {
  let timeline = gsap.timeline({repeat: repeat}); //.yoyo(yoyo)

  timeline.to(el, { backgroundColor: toColor, duration: duration, ease: Power2.EaseIn })
  .to(el, { backgroundColor: "transparent", duration: duration, ease: Power2.EaseOut})

  return timeline
}

/****************  HELP animations   *****************/

export function animateBg(el, reverse = false) {
  let timeline = gsap.timeline()
  if (reverse) {
    timeline.to(el, { backgroundColor: "none", duration: 0.7 })
  } else {
    timeline.to(el, { backgroundColor: "#ff7941", duration: 0.7 })
  }
  return timeline
}

export function animateBg2(el, reverse = false, dur = 0.7) {
  let timeline = gsap.timeline()
  if (reverse) {
    timeline.to(el, { backgroundColor: "none", duration: dur })
  } else {
    timeline.to(el, { backgroundColor: "#c9440b", duration: dur })
  }
  return timeline
}

export function animateBg3(el, reverse = false) {
  let timeline = gsap.timeline()
  if (reverse) {
    timeline.to(el, { backgroundColor: "none", duration: 0.7 })
  } else {
    timeline.to(el, { backgroundColor: "RGBA(151, 222, 121, 0.85)", duration: 0.7 })
    // timeline.to(el, { backgroundColor: "RGBA(151, 222, 121, 0.85)", borderRadius: "20px", duration: 0.7 })
  }
  return timeline
}

export function animateIcon(el, top = false) {
  let timeline = gsap.timeline()
  // console.log(el)
  if (top) {
    timeline.fromTo(
      el,
      { y: -30, opacity: 0, duration: 0.5 },
      { y: 0, opacity: 1 }
    )
  } else {
    timeline.fromTo(
      el,
      { x: 50, opacity: 0, duration: 0.5 },
      { x: 0, opacity: 1 }
    )
    // console.log("ksdxjgldfksj")
  }
  return timeline
}
